import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-limit-counters',
  templateUrl: './limit-counters.page.html',
  styleUrls: ['./limit-counters.page.scss'],
})
export class LimitCountersPage implements OnInit {

  @Input() componentProps: { title: string; description: string; smsCountDown: { countdown: number; time: string; } } = { title: '', description: '', smsCountDown: { countdown: 0, time: '' } };

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onClick = (value: boolean) => this.modalCtrl.dismiss(value);

}
